import Pivot from '../Pivot';
import Schedule from '../Schedule';
import Table from '../Table';
import RevenueMonthlyBudgetPivot from './RevenueMonthlyBudgetPivot';
import TimeMonthlyBudgetPivot from './TimeMonthlyBudgetPivot';

// Registry: tool name → { view type (as emitted by the LLM in its structured output) → Component }.
//
// Design: the LLM owns WHERE in the message a rendered result goes (by emitting
// `{ type: 'pivot' | 'table' | 'chart' | 'schedule', callId }` at that position).
// The tool owns HOW it's rendered, via this registry. If a tool isn't registered
// for a view type, the assistant falls back to the default renderer for that type.
//
// Each entry can either be a fully custom component or a thin wrapper that composes
// a shared component (e.g. Pivot) with tool-specific props (tooltip config, aggregators).
const renderers = {
  'project-revenue-monthly-budget': { pivot: RevenueMonthlyBudgetPivot },
  'project-time-monthly-budget': { pivot: TimeMonthlyBudgetPivot },
  'resource-schedule': { schedule: Schedule },
};

// Default component per view type — used when a tool has no registered override.
// schedule has no generic default; unregistered schedule parts fall back to Table.
const DEFAULT_RENDERERS = {
  pivot: Pivot,
  table: Table,
  schedule: Table,
};

export default renderers;

export function resolveRenderer(toolName, viewType) {
  return renderers[toolName]?.[viewType] ?? DEFAULT_RENDERERS[viewType] ?? null;
}
